define [], () ->
  () ->
    restrict: "E"
    template: require("./unit.jade")
    scope: {field: "=", mode: "@", stage: "=", index: "="}
    link: (scope, element, attrs) ->
      scope.placeholder = 'Example: 100 N. State St. Unit 45. Chicago, IL 60602' 
      scope.editMode = false
      scope.edit = ->
        scope.editMode = true
      scope.save = ->
        scope.editMode = false


// WEBPACK FOOTER //
// ./directives/freeforms/unit/unit.coffee